import { t } from "i18next";

export const tabsItems = ()=>([
    { label: t('home.orders'), key: 'item-1', path: '/orders/business-card' },
    { label: t('orders.salaryCardOrder.constants.newOrders'), key: 'item-2', path: '/orders/business-card/create' },
])
